module.exports = __webpack_public_path__ + "static/media/au-coin.163c25b1.png";